var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodalPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3346 1.6665V6.6665H38.3346V9.99984H33.3346V14.9998H30.0013V9.99984H25.0013V6.6665H30.0013V1.6665H33.3346ZM20.0013 21.6665C21.8346 21.6665 23.3346 20.1665 23.3346 18.3332C23.3346 16.4998 21.8346 14.9998 20.0013 14.9998C18.168 14.9998 16.668 16.4998 16.668 18.3332C16.668 20.1665 18.168 21.6665 20.0013 21.6665ZM23.3346 5.4165V11.6665H28.3346V16.6665H33.2013C33.2846 17.3165 33.3346 17.9832 33.3346 18.6665C33.3346 24.1998 28.8846 30.7498 20.0013 38.3332C11.118 30.7498 6.66797 24.1998 6.66797 18.6665C6.66797 10.3665 13.0013 4.99984 20.0013 4.99984C21.1346 4.99984 22.2513 5.13317 23.3346 5.4165Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodalPoints);
export default __webpack_public_path__ + "static/media/NodalPoints.62be2476d371c6b2ac2e1a3935a68819.svg";
export { ForwardRef as ReactComponent };